import {
  GET_ADMIN_USER_TRANSACTIONS_REQUEST,
  GET_ADMIN_USER_TRANSACTIONS_SUCCESS,
  GET_ADMIN_USER_TRANSACTIONS_MORE_REQUEST,
  GET_ADMIN_USER_TRANSACTIONS_MORE_SUCCESS,
  GET_ADMIN_USER_TRANSACTIONS_TOTAL_REQUEST,
  GET_ADMIN_USER_TRANSACTIONS_TOTAL_SUCCESS,
} from '../../actions/adminPanel/adminUserTransactions';

export default function reducer(
  state = {
    entities: [],
    page: 1,
    pages: 0,
    countItem: 0,
    totalOperations: 0,
    totalUsdVolume: 0,
    fetching: false,
    fetchingMore: false,
  },
  action
) {
  switch (action.type) {
    case GET_ADMIN_USER_TRANSACTIONS_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case GET_ADMIN_USER_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        ...action.payload,
        fetching: false,
      };
    case GET_ADMIN_USER_TRANSACTIONS_MORE_REQUEST:
      return {
        ...state,
        fetchingMore: true,
      };
    case GET_ADMIN_USER_TRANSACTIONS_MORE_SUCCESS:
      return {
        ...state,
        ...action.payload,
        entities: [...state.entities, ...action.payload.entities],
        fetchingMore: false,
      };
    case GET_ADMIN_USER_TRANSACTIONS_TOTAL_REQUEST:
      return {
        ...state,
        totalOperations: 0,
        totalUsdVolume: 0,
      };
    case GET_ADMIN_USER_TRANSACTIONS_TOTAL_SUCCESS:
      return {
        ...state,
        totalOperations: action.payload.totalOperations,
        totalUsdVolume: action.payload.totalUsdVolume,
      };
    default:
      return state;
  }
}
